// import { AuthContext } from 'contexts/AuthContext';
// import { useContext, useEffect, useState } from 'react';
// import { useNavigate } from 'react-router-dom';

// const SelectCourse = ({
//   setDisable,
//   setCourseId,
//   courses,
//   courseId,
//   loadingCourses,
// }) => {
//   const [errors, setErrors] = useState([]);
//   const { state } = useContext(AuthContext);

//   const navigate = useNavigate();

//   const handleCourseChange = (event) => {
//     const selectedCourseId = event.target.value;
//     setCourseId(selectedCourseId);
//   };

//   useEffect(() => {
//     const newErrors = [];
//     if (!courseId) {
//       newErrors.push('Please fill in all fields.');
//     }
//     setErrors(newErrors);
//     setDisable(newErrors.length > 0);
//   }, [courseId, setDisable]);

//   return (
//     <div className="w-full rounded-lg px-3 pt-7 md:px-8">
//       {/* Header */}

//       {/* Course Select */}
//       <div className="mt-6 flex flex-col md:flex-row md:items-center md:justify-center md:gap-6">
//         <div className="w-full md:w-1/2">
//           <label className="ml-3 text-sm font-bold text-navy-700 dark:text-white">
//             Select Course
//           </label>
//           <select
//             onChange={handleCourseChange}
//             value={courseId || ''}
//             name="courseId"
//             className="mt-2 w-full rounded-xl border border-gray-200 py-3 pl-2.5 pr-3 text-sm font-normal outline-none dark:!border-white/10 dark:!bg-navy-800 dark:text-white"
//           >
//             <option value="">Click here to Select Course</option>
//             {loadingCourses ? (
//               <option>Loading courses...</option>
//             ) : courses.length === 0 ? (
//               <option className="cursor-pointer font-bold text-brand-500">
//                 No courses available
//               </option>
//             ) : (
//               courses.map((course, i) => (
//                 <option key={course.courseId} value={course.courseId}>
//                   {i + 1}. {course.courseName}
//                 </option>
//               ))
//             )}
//           </select>
//         </div>
//       </div>

//       {/* Display errors */}
//       {errors.length > 0 && (
//         <div className="text-red-500">
//           {errors.map((error, index) => (
//             <p key={index}>{error}</p>
//           ))}
//         </div>
//       )}
//     </div>
//   );
// };

// export default SelectCourse;
import { AuthContext } from 'contexts/AuthContext';
import { useContext, useEffect, useState } from 'react';

const SelectCourse = ({
  setDisable,
  setCourseId,
  courses,
  courseId,
  loadingCourses,
}) => {
  const [errors, setErrors] = useState([]);
  const { state } = useContext(AuthContext);

  const handleCourseChange = (event) => {
    const selectedCourseId = event.target.value;
    setCourseId(selectedCourseId);
  };

  useEffect(() => {
    const newErrors = [];
    if (!courseId) {
      newErrors.push('Please select a course.');
    }
    setErrors(newErrors);
    setDisable(newErrors.length > 0);
  }, [courseId, setDisable]);

  return (
    <div className="w-full rounded-lg px-3 pt-7 md:px-8">
      {/* Course Select */}
      <div className="mt-6 flex flex-col md:flex-row md:items-center md:justify-center md:gap-6">
        <div className="w-full md:w-1/2">
          <label className="ml-3 text-sm font-bold text-navy-700 dark:text-white">
            Select Course
          </label>

          <select
            onChange={handleCourseChange}
            value={courseId || ''}
            name="courseId"
            className="mt-2 w-full rounded-xl border border-gray-200 py-3 pl-2.5 pr-3 text-sm font-normal outline-none dark:!border-white/10 dark:!bg-navy-800 dark:text-white"
          >
            <option value="">Click here to Select Course</option>

            {loadingCourses ? (
              <option disabled>Loading courses...</option>
            ) : courses.length === 0 ? (
              <option disabled>No courses available</option>
            ) : (
              courses.map((course, index) => (
                <option key={course._id} value={course._id}>
                  {index + 1}. {course.courseName}
                </option>
              ))
            )}
          </select>
        </div>
      </div>

      {/* Errors */}
      {errors.length > 0 && (
        <div className="mt-2 text-sm text-red-500">
          {errors.map((error, index) => (
            <p key={index}>{error}</p>
          ))}
        </div>
      )}
    </div>
  );
};

export default SelectCourse;
